module.exports = __webpack_public_path__ + "media/new-sales.191725d8.mp3";